export const CONNECTIONS_METADATA = [
  { key: "googleSheet", value: "Google Spreadsheet" },
  { key: "supabase", value: "Supabase DB" },
];
